import { ForwardMessageProps } from "./types"
import React, { useState, useMemo } from "react"
import { observer } from "mobx-react-lite"
import useNavigation from "~hooks/useNavigation"
import useSelectPageEffect from "~hooks/useSelectPageEffect"
import { SearchBarWithAvatars } from "~components/search-bar-with-avatars"
import { ChatList } from "~components/chat-list"
import { newID } from "~utils"
import { useStores } from "~models"
import styled from '~/ui/styled'

const Container = styled.SafeAreaView`
  flex: 1;
`

const ForwardMessage: React.FC<ForwardMessageProps> = ({ messageID }) => {
  const {
    chatStore,
    userStore: { currentUser, users },
    messageStore: { messages, sendBatchMessage },
  } = useStores()
  const navigation = useNavigation()
  const { chats, current } = chatStore
  const [search, setSearch] = useState("")
  const [selecteds, setSelecteds] = useState([])
  const canSubmit = useMemo(() => selecteds.length > 0, [selecteds])

  const message = messages.get(messageID)

  const data = chatStore.search(search).filter(({ chat_id }) => chat_id !== current.chat_id)

  const avatars = selecteds.map((s) => {
    const chat = chats.get(s)
    return {
      title: chat.title,
      avatar: chat.image,
    }
  })

  async function onSubmit() {
    if (!canSubmit) return
    const messages = selecteds.map((id) => {
      const chat = chats.get(id)
      const m = {
        ...message,
        message_id: newID(),
        sender_id: currentUser.id,
        receiver: ["GROUP", "CHANNEL"].includes(chat.chatTypeEnum) ? null : users.get(id),
        chat_id: chat.id,
        chat_cid: chat.chat_id,
        forward_msg_id: message.message_id,
        forward_user_id: message.sender.id,
        forward_name: message.sender.name,
      }
      return m
    })
    sendBatchMessage(messages)
    navigation.goBack()
  }

  useSelectPageEffect({
    canSubmit,
    onSubmit,
    selecteds,
  })

  return (
    <Container>
      <SearchBarWithAvatars
        selecteds={avatars}
        search={search}
        setSearch={setSearch}
        inputSetting={{
          placeholder: "请输入群聊名称",
        }}
      />
      <ChatList
        data={data}
        selecteds={selecteds}
        onItemClick={(chat) => {
          const { chat_id: id } = chat
          if (selecteds.find((x) => x === id)) {
            setSelecteds(selecteds.filter((x) => x !== id))
          } else {
            setSelecteds([...selecteds, id])
          }
        }}
      />
    </Container>
  )
}
export default observer(ForwardMessage)
